import { IconButton } from "@fluentui/react";
import { AttachmentComponent } from "ccs-azure";
import * as React from "react";
import { useRef } from "react";
import "./AttachmentUploadIcon.scss";

export const AttachmentUploadIcon: React.FunctionComponent<React.ComponentProps<typeof AttachmentComponent>> = (props) => {
  const attachmentControlRef = useRef<AttachmentComponent>(null);
  const hasAttachment = props.fileMode === "SingleFile" ? Boolean(props.attachment) : Boolean(props.attachments?.length);
  const displayStyle = props.displayStyle || (props.fileMode === "SingleFile" ? "inline-block" : "block");
  const isUploadButtonEnabled =
    !props.readonly && (props.fileMode === "MultiFile" || (displayStyle === "inline-block" && !hasAttachment) || displayStyle === "block");

  const triggerAttachmentUpload = () => {
    const control = attachmentControlRef.current as unknown as {
      fileInputRef?: React.RefObject<HTMLInputElement>;
    };
    control.fileInputRef?.current?.click();
  };

  return (
    <div className="attachmentUploadIconWrapper">
       {isUploadButtonEnabled && (
        <IconButton
          className="attachmentUploadIcon"
          iconProps={{ iconName: "CloudUpload" }}
          ariaLabel={props.texts?.labelAddFile || "Add file"}
          title={props.texts?.labelAddFile || "Add file"}
          onClick={triggerAttachmentUpload}
        />
      )}
      <AttachmentComponent ref={attachmentControlRef} {...props} />
     
    </div>
  );
};
